// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vJ_8","colMin":"styles_colMin__23ZSK"};